import React from "react";
import {Modal, message, Space, Button} from "antd";
import {Spacer} from "../../../../components/DesignSystem/Spacer/Spacer";
import {Prompts, Sender} from "@ant-design/x";
import {chatService} from "../../../../services/chatService";
import {generateQueryPrompt, getSQLResponseBlocks} from "../../../../utils/ai.utils";
import {BulbOutlined} from "@ant-design/icons";
import {Spinner} from "../../../../components/DesignSystem/Spinner/Spinner";

export const SqlAssistantModal = ({onQuery, onClose, tables, chatId}) => {

    const [loading, setLoading] = React.useState(false);
    const [loadingMessage, setLoadingMessage] = React.useState('Loading...');
    const [value, setValue] = React.useState('');
    const [suggestions, setSuggestions] = React.useState([]);

    const onSubmit = () => {

        const prompt = value;

        setValue('');
        setLoading(true);

        const query = generateQueryPrompt(tables, prompt)

        chatService.ask(chatId, query).then(response => {

            const blocks = getSQLResponseBlocks(response.data);

            if (blocks.length === 0) {
                message.error("No SQL blocks found in the response. Please try again with a different query.");
                return;
            } else {
                onQuery(blocks[0]);
            }

        }).catch(error => {
            console.error("Error asking AI Assistant:", error);
            message.error("Failed to communicate with AI Assistant. Please try again later.");
        }).finally(() => {
            setLoading(false);
        });

    }

    const onSelectSuggestion = (query) => {
        onQuery(query);
    }

    const handleSuggestion = () => {

        setLoading(true);

        const query = generateQueryPrompt(tables, `Give me some suggestions for SQL select queries based on the provided tables. Ouptput format:"
        {
            "suggestions": [
            {
                "title": "Select all customers",
                "sql": "SELECT * FROM customers_10000;"
            },
            {
                "title": "Count customers by country",
                "sql": "SELECT \"Country Name\", COUNT(*) FROM customers_10000 GROUP BY \"Country Name\";"
            }
        ]
        }`);

        chatService.ask(chatId, query).then(response => {

            const d = response.data.suggestions.map((item, index) => ({
                key: index,
                icon: <BulbOutlined style={{color: '#FFD700'}}/>,
                label: item.title,
                description: item.sql,
            }));

            setSuggestions(d || []);

        }).catch(error => {
            message.error("Failed to fetch suggestions. Please try again later.");
        }).finally(() => {
            setLoading(false);
        });

    }

    const isDisabled = () => {
        return loading;
    }

    return <Modal width={1000}
                  title="Query assistant"
                  centered
                  open={true}
                  onCancel={onClose}
                  footer={null}
    >
        <Spacer size={"large"}/>

        <Spinner spinning={loading}>
            <Sender
                loading={loading}
                value={value}
                onChange={v => {
                    setValue(v);
                }}
                onSubmit={onSubmit}
                placeholder="Type your query here or click the lightbulb for suggestions"
                onCancel={() => {
                    setLoading(false);
                    message.error('Cancel sending!');
                }}
                allowSpeech={true}
                actions={(_, info) => {
                    const {SendButton, SpeechButton} = info.components;
                    return (
                        <Space size="small">
                            <Button type={"text"} icon={<BulbOutlined/>} onClick={handleSuggestion} title={"Give me some suggestions"}
                                    disabled={isDisabled()}/>
                            <SpeechButton disabled={isDisabled()}/>
                            <SendButton type="primary" disabled={isDisabled()}/>
                        </Space>
                    );
                }}
                autoSize={{minRows: 1, maxRows: 6}}
            />
            <Spacer size={"large"}/>
            {suggestions.length > 0 && (
            <Prompts
                items={suggestions}
                onItemClick={info => {
                    onSelectSuggestion(info.data.description);
                }}
                wrap
                styles={{
                    item: {
                        flex: 'none',
                        width: 'calc(50% - 6px)',
                    },
                }}
            />)}
        </Spinner>
    </Modal>

}